import { render, staticRenderFns } from "./BulkImageEditModal.vue?vue&type=template&id=f128e66c&"
import script from "./BulkImageEditModal.vue?vue&type=script&lang=ts&"
export * from "./BulkImageEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports